import { useMemo } from 'react';

import BankCardLogo from 'assets/images/bank-card-logo.svg';
import LeftMobile from 'assets/images/left-mobile.svg';
import MobileOperatorLogo from 'assets/images/mobile-operator-logo.svg';
import Plus24Logo from 'assets/images/wallt-24-logo.svg';
import { PAY_METHOD, PAY_TYPE } from 'constants/payment';
import { useIsMobile, useTranslate } from 'hooks';
import { useAppSelector } from 'store/hooks';

const TitlePaymentMethod = ({ closePaymentMethod }: { closePaymentMethod: () => void }) => {
  const { paymentData, acquiring, isOnlyBankCard } = useAppSelector((state) => state.payment);
  const { isMobile } = useIsMobile();
  const { t } = useTranslate();

  const { title, icon } = useMemo(() => {
    const getInfoByType = () => {
      if (paymentData?.paymentType === PAY_TYPE.PAYMENT) {
        switch (acquiring?.formType) {
          case PAY_METHOD.PLUS24_2:
            return {
              icon: Plus24Logo,
              title: t('lang.pay_by_plus24'),
            };
          case PAY_METHOD.MOBILE:
            return {
              icon: MobileOperatorLogo,
              title: t('lang.pay_by_phone'),
            };
          case PAY_METHOD.BANK_CARD_1:
          case PAY_METHOD.BANK_CARD_9:
          default:
            return {
              icon: BankCardLogo,
              title: t('lang.pay_by_bank'),
            };
        }
      }

      if (paymentData?.paymentType === PAY_TYPE.PAYOUT) {
        switch (acquiring?.formType) {
          case PAY_METHOD.PLUS24_7:
            return {
              icon: Plus24Logo,
              title: t('lang.payout_to_plus24'),
            };
          case PAY_METHOD.MOBILE:
            return {
              icon: MobileOperatorLogo,
              title: t('lang.payout_to_phone_number'),
            };
          case PAY_METHOD.BANK_CARD_3:
          default:
            return {
              icon: BankCardLogo,
              title: t('lang.payout_to_bank_card'),
            };
        }
      }

      return {
        icon: BankCardLogo,
        title: '',
      };
    };

    return getInfoByType();
  }, [paymentData, acquiring, t]);

  const close = () => {
    if (isMobile) {
      closePaymentMethod();
    }
  };

  return (
    <button
      type="button"
      className="flex items-center gap-2 font-bold leading-5 text-base w-full"
      onClick={close}
    >
      {!isOnlyBankCard && <img src={LeftMobile} alt="left-icon" className="block md:hidden" />}
      <div className="flex items-center gap-2 justify-start md:justify-normal flex-grow">
        <img src={icon} alt="icon" className="hidden md:block w-6 h-6" />
        <span>{title}</span>
      </div>
    </button>
  );
};

export { TitlePaymentMethod };
